module.exports = __webpack_public_path__ + "202419:4ba491f0bd9615732354/img/heroMobile@1x.dd0c66c.png";